import React from 'react';
import styled from 'styled-components'

import Button from '../../../Button/Button'
import { Link } from 'react-router-dom'
import { Black, WerfenColorLight, White } from '../../../../Constants/ColorChart'

/*
 *  @Description:   Stateless component that renders a Section with a button that will send the user to a "User's Guide".
 */
const StyledLink = styled( Link )`
    text-decoration: none;
    &:hover{
        text-decoration: none;
    }
`;
const Title = styled.p`
    font-size: 60px;
    font-weight: 500;
    text-align: center;
    @media (max-width: 992px){
        font-size: 40px;
    }
`;

const WrapperDiv = styled.div`
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: ${ Black };
    margin-top: 100px;
    margin-bottom: 100px;
`;


const AboutSection = () => {

    return (
        <WrapperDiv id="About">
            <Title>All about { process.env.REACT_APP_SITE_APP_NAME } </Title>
            <StyledLink to="/faq">
                <Button centered text="See FAQ" background={ WerfenColorLight } color={ White }/>
            </StyledLink>
        </WrapperDiv>
    )

}


export default AboutSection;
